import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const TagsClientManager = (function($) {

	var restUrl = LS2PAC_CONSTANTS.restUrls.addTag;

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddTag, function(event) {
		onAddTag(event.resource, event.tag, true);
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onDeleteTag, function(event) {
		onDeleteTag(event.resource, event.tagId);
	});

	var onAddTag = function(resource, tag, userEntered) {
		var success = false;

		var tagString = tag.trim();

		if(tagString != "") {
			var newTag;
			TLCRest.jsonCall(restUrl, {
				postData: {resourceId: resource.id, tag: tag.trim(), userEntered: userEntered},
				callback: function(newTagResponse) {
					if(newTagResponse) {
						success = true;
						newTag = newTagResponse;
						resource.tags = resource.tags || [];
						var shouldPush = true;

						$.each(resource.tags, function(index, tag) {
							if(newTagResponse.data == tag.data) {
								shouldPush = false;
								tag.count += 1;
							}
						});

						if(shouldPush) {
							resource.tags.push(newTagResponse);
						} else {
							newTag = null;
						}
					}
				},
				finallyHandler: function(response) {
					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onAddTagResponse, {success: success, tag: newTag});
				}
			});
		} else {
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onAddTagResponse, {success: true, tag: null});
		}

	};

	var onDeleteTag = function(resource, tagId) {
		$.ajax({
			'url': restUrl + '/' + resource.id + '/' + tagId,
			'type': 'DELETE',
			'success': function() {
				$.each(resource.tags, function(index, tag) {
					if(tag.id === tagId) {
						resource.tags.splice(index, 1);
						TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onDeleteTagResponse, {tagId: tagId});
						return false;
					}
				});
			}
		});
	};

	return {};
})(jQuery);

